import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-4 md:py-8 text-center" data-id="element-0">
    <p className="text-lg md:text-2xl font-display italic text-brand-violetDark/85 leading-relaxed font-[800]" data-id="element-1">
      La próxima semana puede ser diferente.
    </p>
  </div>;
import { SacredCircle, FamilyTree, OpenJournal, CandleFlame, TearDrop } from './components/SacredIcons';
const GlobalBackground = () => <div className="fixed inset-0 pointer-events-none overflow-hidden -z-20 opacity-[0.08]" data-id="element-2">
    {/* Scattered Mandalas */}
    <SacredCircle className="absolute -top-20 -left-20 w-96 h-96 text-brand-violet" data-id="element-3" />
    <SacredCircle className="absolute top-1/3 -right-32 w-[500px] h-[500px] text-brand-gold" data-id="element-4" />
    <SacredCircle className="absolute bottom-0 left-1/4 w-80 h-80 text-brand-rose" data-id="element-5" />

    {/* Scattered Lavender & Leaves */}
    <FamilyTree className="absolute top-1/4 left-10 w-24 h-24 transform -rotate-12" data-id="element-6" />
    <TearDrop className="absolute top-1/2 right-20 w-16 h-24 transform rotate-45" data-id="element-7" />
    <FamilyTree className="absolute bottom-1/4 right-10 w-32 h-32 transform rotate-12" data-id="element-8" />

    {/* Scattered Planner Elements */}
    <OpenJournal className="absolute top-20 right-1/4 w-20 h-20 transform rotate-12" data-id="element-9" />
    <CandleFlame className="absolute bottom-1/3 left-20 w-12 h-20 transform -rotate-45" data-id="element-10" />
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-gold/25 selection:text-brand-violetDark bg-brand-surface relative" data-id="element-11">
      <GlobalBackground data-id="element-12" />
      <UrgencyBanner data-id="element-13" />
      <Hero data-id="element-14" />
      <PainPoints data-id="element-15" />
      <MethodOverview data-id="element-16" />
      <MaterialPreview data-id="element-17" />
      <MoreTestimonials data-id="element-18" />
      <Guarantee data-id="element-19" />
      <FAQ data-id="element-20" />
      <CostComparison data-id="element-21" />
      <TransitionPhrase data-id="element-22" />
      <EmotionalClose data-id="element-23" />
      <Footer data-id="element-24" />
      <FloatingNotification data-id="element-25" />
    </div>;
}